import { NgZone } from '@angular/core';

/**
 * A callback run back in Angular's zone. In this app an HTTP response can arrive outside the zone (the token
 * interceptor reads async storage), and the Suburbs popup wouldn't redraw until the next click; so every response
 * handler in the tool goes through this, and then asks for a redraw.
 */
export function inZone<T>(zone: NgZone, fn: (value: T) => void): (value: T) => void {
  return (value: T) => zone.run(() => fn(value));
}
